import {useState, useContext} from 'react';
import {UserContext} from "../../App"
import {Activite} from "./Activite"
import {color_note, currentPeriod, IsInPeriod} from "../Fonctions"
import './Classe.css';


export function Classe ({classe}) {
  //console.log(user.activite_faites[classe])
  
  const {currentUser} = useContext(UserContext)
  const user = currentUser

  const tab = Object.keys(user.activite_faites[classe]).map(e=>user.activite_faites[classe][e][0])
  const d = new Date()
  const j = d.getDate()
  const m = d.getMonth()+1
  tab.sort((a, b) => a.donne_le.slice(0,2) < b.donne_le.slice(0,2)).sort((a, b) => a.donne_le.slice(3,5) < b.donne_le.slice(3,5))
  const tab1 = tab.filter(e=>(e.donne_le.slice(0,2) <= j && e.donne_le.slice(3,5)*1 === m) || e.donne_le.slice(3,5) < m)
  const tab2 = tab.filter(e=>e.donne_le.slice(3,5) > m)

  let tab_activ = [...tab1, ...tab2]

  // =========== Période =========== 
  const tab_period = [
    '2024-09-01_2024-11-15',
    '2024-11-16_2024-03-10',
    '2024-03-11_2024-06-30',
  ]

  let period = currentPeriod(tab_period) 
  //tab_activ = tab_activ.filter(activ => IsInPeriod(activ.donne_le, period))

  //console.log(currentPeriod(tab_period))
  /*const start_month = period.slice(5,7)*1
  const start_day = period.slice(8,10)*1
  const end_month = period.slice(16,18)*1
  const end_day = period.slice(19,21)*1

  if (start_month > end_month){
    tab_activ = tab_activ.filter(e=>e.donne_le.slice(3,5) >= start_month && e.donne_le.slice(3,5) <= 12 || e.donne_le.slice(3,5) >= 1 && e.donne_le.slice(3,5) <= end_month)
    .filter(e=>e.donne_le.slice(0,2) >= start_day && e.donne_le.slice(3,5) == start_month || e.donne_le.slice(3,5) != start_month)
    .filter(e=>e.donne_le.slice(0,2) <= end_day && e.donne_le.slice(3,5) == end_month || e.donne_le.slice(3,5) != end_month)
  } else {
    tab_activ = tab_activ.filter(e=>e.donne_le.slice(3,5) >= start_month && e.donne_le.slice(3,5) <= end_month)
    .filter(e=>e.donne_le.slice(0,2) >= start_day && e.donne_le.slice(3,5) == start_month || e.donne_le.slice(3,5) > start_month)
    .filter(e=>e.donne_le.slice(0,2) <= end_day && e.donne_le.slice(3,5) == end_month || e.donne_le.slice(3,5) < end_month)
  }*/
  // ===========================

  const maq_activites = []
  if (currentUser.MAQ.length) {
    currentUser.MAQ.forEach(e => {
      if (!maq_activites.includes(e.activite) && e.classe === classe) {maq_activites.push(e.activite)}
    })
  }
  //console.log(tab[0].dates.slice(3,5)) 

  const [modal, setModal] = useState('')

  const dl_info = (activite, eleves) => {
    let csv = 'Moyenne des activites de ' + classe+'\n\n'
   user.moyenne_indiv[classe]?.forEach(e => {
      csv += e[1] + ' ' + e[0] + ',' + e[2] + ',%\n'
    })
   csv += '\nMoyenne des activites : ,' + user.moyenne_grp[classe]?.moyenne + ',%\n\n' + 
              'Moyenne min : ,' + user.moyenne_grp[classe]?.min + ',%\n\n' +
              'Moyenne max : ,' + user.moyenne_grp[classe]?.max + ',%\n\n' 
    const a = document.getElementById('dl_moyenne')
    a.href = "data:text/csv;base64," + btoa(csv)
    
  }

  //console.log(user)
  //console.log(user.activite_faites[classe])
  //console.log(tab_activ)
  return (
    <div>
    	<h1>Classe de {classe}</h1>
      {Object.keys(user.activite_faites[classe]).length ? 
      <>
    	<h2>Résultats Automaths</h2>
      <div className="liste_eleve" style={{top:270+57*user.liste_classes.length, textAlign:"center"}} >
        <h2 title={user.mes_classes[classe]?.length}>La classe</h2>
        {user.mes_classes[classe]?.map(e => <span key={e.id} title={e.prenom+' '+e.nom+' dernière connexion le '+e.ddc.slice(-2)+'/'+e.ddc.slice(-5,-3)}>{e.nom.slice(0, 1)} {e.prenom}<br/></span>)}
      </div>
      <span dangerouslySetInnerHTML={{ __html:modal}}></span>
      <div className="tableau c4 adapt">
    	 {tab_activ.map((act, k) => <Activite key={k} setModal={setModal} activite={act.activite} eleves={user.activite_faites[classe][act.activite]} effectif={user.mes_classes[classe].length} />)} 
      </div>
      
      <div className="content max" style={{opacity:user.moyenne_grp[classe].moyenne ? 1 : 0}} >
        <h2>Quelques Statistiques...</h2>
        <b>Sauvegarder les moyennes :</b> <a id="dl_moyenne" style={{fontSize:"1.5em", cursor:"pointer"}} onClick={dl_info}>📁</a><br/>

        {/* ======= Moyenne des activités ======= */}
        <div className="card title">
          <h1>Moyenne activités</h1>
          <h2>{classe}</h2>
          <span className={"card_note "+color_note(user.moyenne_grp[classe].moyenne)} title="Il s'agit de la moyenne brute">{user.moyenne_grp[classe].moyenne}%</span>
          <div className="contains">
            <span className="p1" title="Statistiques sur les essais">
              Essais moyen : {user.essais[classe]?.moyenne} <br/>
              Essais médian : {user.essais[classe]?.mediane}  
            </span>
            <br/>
            <span className="p2" title="Ecart-type sur les activités">
              Ecart-type : {user.moyenne_grp[classe]?.ecart_type}  
            </span>
          </div>
        </div>

        {/* ======= Min des activités ======= */}
        <div className="card title">
          <h1>Moyenne min</h1>
          <h2>des activités</h2>
          <span className={"card_note "+color_note(user.moyenne_grp[classe]?.min)} title="Il s'agit de la moyenne brute">{user.moyenne_grp[classe]?.min}%</span>
          <span dangerouslySetInnerHTML={{ __html:user.moyenne_grp[classe]?.activ_min}}></span>
          </div>

        {/* ======= Max des activités ======= */}
        <div className="card title">
          <h1>Moyenne max</h1>
          <h2>des activités</h2>
          <span className={"card_note "+color_note(user.moyenne_grp[classe]?.max)} title="Il s'agit de la moyenne brute">{user.moyenne_grp[classe]?.max}%</span>
          <span dangerouslySetInnerHTML={{ __html:user.moyenne_grp[classe]?.activ_max}}></span>
        </div>

        {/* ======= Liste élèves ======= */}
        {user.moyenne_indiv[classe]?.map((e,key_moy) => 
          <div className="card" key={key_moy}>
            <h1>{e[0]}</h1>
            <h2>{e[1]}</h2>
            <span className={"card_note "+color_note(e[2])} title="Il s'agit de la moyenne brute">{e[2]}%</span>
            {e[3]?.nb_zero ? <span className="zero" title={'dont '+e[3]?.nb_zero+' zéros obtenus sur \u000d' + e[3]?.nb_zero_act.replaceAll('&#10;', '\u000d')}>{e[3]?.nb_zero}</span>:''}
            <span className="essais" title={"Nombre d'essais moyen "+e[4]?.moy_essais+" \u000dNombre d'essais min : "+e[4]?.min+" sur "+e[4]?.activ_min+" \u000dNombre d'essais max "+e[4]?.max+" sur "+e[4]?.activ_max}>{e[4]?.moy_essais}</span> 
            <div className="contains">
            <span className="p1" title="Note min avec activités correspondantes">
            <h1>{e[3]?.min}%</h1>
            <span dangerouslySetInnerHTML={{ __html:e[3]?.min_act_br}}></span>
            </span>
            <br/>
            <span className="p2" title="Note max avec activités correspondantes">
            <h1>{e[3]?.max}%</h1>
            <span dangerouslySetInnerHTML={{ __html:e[3]?.max_act_br}}></span>
            </span>
          </div>
          </div>
        )}
      </div>

      {maq_activites.length ? 
        <>
        <h2>Maths au quotidien</h2>
        <div className="tableau c4 adapt">
          {
            maq_activites.map((act, key)=>
              <div className='case compte question_flash'>
                  <h1>{act}</h1>
                  {currentUser.MAQ.map((e, k) => (e.classe === classe && e.activite === act) &&
                      <span className={color_note(e.note)} title={e.prenom +' '+ e.nom+'\u000dLe '+(e.dates.split('-')[2]+'/'+e.dates.split('-')[1]+'/'+e.dates.split('-')[0])}>{e.prenom} : {e.note}%<br/></span>
                    )}
              </div>)
          } 
        </div>
        </> : ''
      }
      </>
      : <div className="alert info ">
              <br/>Vous n'avez pas encore de résultat pour cette classe.<br/><br/>
        </div>
      }
    </div>
  );
}